import api from './axios';
import { Ticket, TicketStatus } from '../types';

export interface TicketQuery {
  orderId?: number;
  stationId?: number;
  status?: TicketStatus;
  from?: string;
  to?: string;
}

export const ticketsApi = {
  getAll: (params?: TicketQuery) =>
    api.get<Ticket[]>('/tickets', { params }),

  getById: (id: number) =>
    api.get<Ticket>(`/tickets/${id}`),

  reprint: (id: number) =>
    api.post<{ ticket: Ticket; printed: boolean; reason?: string }>(`/tickets/${id}/reprint`),
};
